(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const closeSiblingItems = (openedItem) => {
      const itemsContainer = openedItem.closest('.collapsible-tabs__items');
      if (!itemsContainer) return;

      const openItems = itemsContainer.querySelectorAll('.collapsible-tabs__item[open]');
      openItems.forEach((item) => {
        if (item === openedItem) return;
        item.removeAttribute('open');
      });
    };

    const sections = document.querySelectorAll('[data-collapsible-tabs]:not([data-tabs-ready])');

    sections.forEach((sectionEl) => {
      sectionEl.setAttribute('data-tabs-ready', 'true');

      const tabs = Array.from(sectionEl.querySelectorAll('[role="tab"]'));
      const panels = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));
      const accordionItems = Array.from(sectionEl.querySelectorAll('.collapsible-tabs__item'));

      if (!tabs.length || !panels.length) return;

      const activateTab = (targetTab, shouldFocus = false) => {
        const tabId = targetTab.dataset.tabTarget;

        tabs.forEach((tab) => {
          const isActive = tab === targetTab;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== tabId;
        });

        if (shouldFocus) targetTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });

      const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(selectedTab);

      accordionItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          closeSiblingItems(item);
        });
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const blockEl = event.target.closest('[data-block-id]');
      if (!blockEl) return;

      const sectionEl = blockEl.closest('[data-collapsible-tabs]');
      if (!sectionEl) return;

      const tabId = blockEl.dataset.tabId;
      if (!tabId) return;

      const targetTab = sectionEl.querySelector(`[data-tab-target="${tabId}"]`);
      if (!targetTab) return;

      const allTabs = Array.from(sectionEl.querySelectorAll('[role="tab"]'));
      const allPanels = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));

      allTabs.forEach((tab) => {
        const isActive = tab === targetTab;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      allPanels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== tabId;
      });

      closeSiblingItems(blockEl);
      blockEl.setAttribute('open', 'open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-collapsible-tabs]:not([data-tabs-ready])');

    sections.forEach((sectionEl) => {
      sectionEl.setAttribute('data-tabs-ready', 'true');

      const tabs = Array.from(sectionEl.querySelectorAll('[role="tab"]'));
      const panels = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));

      if (!tabs.length || !panels.length) return;

      const activateTab = (targetTab, shouldFocus = false) => {
        const tabId = targetTab.dataset.tabTarget;

        tabs.forEach((tab) => {
          const isActive = tab === targetTab;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== tabId;
        });

        if (shouldFocus) targetTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });

      const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(selectedTab);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const blockEl = event.target.closest('[data-block-id]');
      if (!blockEl) return;

      const sectionEl = blockEl.closest('[data-collapsible-tabs]');
      if (!sectionEl) return;

      const tabId = blockEl.dataset.tabId;
      if (!tabId) return;

      const targetTab = sectionEl.querySelector(`[data-tab-target="${tabId}"]`);
      if (!targetTab) return;

      const allTabs = Array.from(sectionEl.querySelectorAll('[role="tab"]'));
      const allPanels = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));

      allTabs.forEach((tab) => {
        const isActive = tab === targetTab;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      allPanels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== tabId;
      });

      blockEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
